import React, { useEffect, useState } from "react";
import { Button, Input, Select, Switch } from "antd";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { ApiURL } from "../../../../services/apiConstants";
import { post } from "../../../../services/services";

function ShipMainEngineDetails({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [number_of_main_engine, set_number_of_main_engine] = useState("1");
  const [main_engine_make, set_main_engine_make] = useState("");
  const [main_engine_model, set_main_engine_model] = useState("");
  const [power_rpm_mcr, set_power_rpm_mcr] = useState("");
  const [power_rpm_ncr, set_power_rpm_ncr] = useState("");
  const [no_of_cylinder, set_no_of_cylinder] = useState("");
  const [select_engine_number, set_select_engine_number] = useState("");
  const [mcr_rpm, set_mcr_rpm] = useState("");
  const [ncr_rpm, set_ncr_rpm] = useState("");
  const [checked, setChecked] = useState(true);
  const [epl_mcr, set_epl_mcr] = useState("");
  const [epl_rpm, set_epl_rpm] = useState("");

  const ADD_API = () => {
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("number_of_main_engine", number_of_main_engine);
      FORM_DATA.append("main_engine_make", main_engine_make);
      FORM_DATA.append("main_engine_model", main_engine_model);
      FORM_DATA.append("power_rpm_mcr", power_rpm_mcr);
      FORM_DATA.append("power_rpm_ncr", power_rpm_ncr);
      FORM_DATA.append("no_of_cylinder", no_of_cylinder);
      FORM_DATA.append("request_type", "add-edit");
      FORM_DATA.append("mcr_rpm", mcr_rpm);
      FORM_DATA.append("ncr_rpm", ncr_rpm);
      FORM_DATA.append("epl_status", checked);
      FORM_DATA.append("epl_mcr", epl_mcr);
      FORM_DATA.append("epl_rpm", epl_rpm);
      post(ApiURL.ship_main_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Congratulation!!", res?.message);
          set_loader(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("request_type", "view");
      FORM_DATA.append("main_engine_number", number_of_main_engine);
      post(ApiURL.ship_main_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          // set_number_of_main_engine(
          //   res?.main_engine_data?.number_of_main_engine || select_engine_number
          // );
          set_main_engine_make(res?.main_engine_data?.main_engine_make);
          set_main_engine_model(res?.main_engine_data?.main_engine_model);
          set_power_rpm_mcr(res?.main_engine_data?.power_rpm_mcr);
          set_power_rpm_ncr(res?.main_engine_data?.power_rpm_ncr);
          set_no_of_cylinder(res?.main_engine_data?.no_of_cylinder);
          set_mcr_rpm(res?.main_engine_data?.mcr_rpm);
          set_ncr_rpm(res?.main_engine_data?.ncr_rpm);
          setChecked(res?.main_engine_data?.epl_status);
          set_epl_mcr(res?.main_engine_data?.epl_mcr);
          set_epl_rpm(res?.main_engine_data?.epl_rpm);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  useEffect(() => {
    if (select_engine_number) {
      set_main_engine_make("");
      set_main_engine_model("");
      set_power_rpm_mcr("");
      set_power_rpm_ncr("");
      set_no_of_cylinder("");
    }
  }, [select_engine_number]);

  useEffect(() => {
    if (id) {
      VIEW_API();
    }
  }, [id, select_engine_number]);

  return (
    <>
      <h3 style={{ marginTop: "15px" }}>Ship Main Engine Information </h3>
      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>Number of main engine</label>
            <Select
              value={number_of_main_engine}
              placeholder="--count of main engine --"
              style={{ width: "100%" }}
              onChange={(value) => {
                set_select_engine_number(value);
                set_number_of_main_engine(value);
              }}
            >
              <Select.Option value="1">1</Select.Option>
              <Select.Option value="2">2</Select.Option>
            </Select>
            {errors?.number_of_main_engine && (
              <>
                <span style={{ color: "red" }}>{errors?.number_of_main_engine}</span>
              </>
            )}
          </div>
        </div>

        <div className="col-6">
          <div className="input-box">
            <label>Main engine make</label>
            <Input
              value={main_engine_make}
              placeholder="Main engine make"
              onChange={(e) => set_main_engine_make(e.target.value)}
            />
            {errors?.main_engine_make && (
              <>
                <span style={{ color: "red" }}>{errors?.main_engine_make}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>Main engine model</label>
            <Input
              value={main_engine_model}
              placeholder="Main engine model"
              onChange={(e) => set_main_engine_model(e.target.value)}
            />
            {errors?.main_engine_model && (
              <>
                <span style={{ color: "red" }}>{errors?.main_engine_model}</span>
              </>
            )}
          </div>
        </div>

        <div className="col-6">
          <div className="input-box">
            <label>Number of Cylinder</label>
            <Select
              value={no_of_cylinder}
              placeholder="--count of Cylinder --"
              style={{ width: "100%" }}
              onChange={(value) => set_no_of_cylinder(value)}
            >
              {Array.from({ length: 10 }, (_, i) => (
                <Select.Option key={i + 1} value={i + 1}>
                  {i + 1}
                </Select.Option>
              ))}
            </Select>
            {errors?.no_of_cylinder && (
              <>
                <span style={{ color: "red" }}>{errors?.no_of_cylinder}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>MCR Power</label>
            <Input
              value={power_rpm_mcr}
              placeholder="MCR Power"
              onChange={(e) => set_power_rpm_mcr(e.target.value)}
            />
            {errors?.power_rpm_mcr && (
              <>
                <span style={{ color: "red" }}>{errors?.power_rpm_mcr}</span>
              </>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>MCR RPM</label>
            <Input
              value={mcr_rpm}
              placeholder="MCR RPM"
              onChange={(e) => set_mcr_rpm(e.target.value)}
            />
            {errors?.mcr_rpm && (
              <>
                <span style={{ color: "red" }}>{errors?.mcr_rpm}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="input-box">
            <label>NCR Power</label>
            <Input
              value={power_rpm_ncr}
              placeholder="NCR Power"
              onChange={(e) => set_power_rpm_ncr(e.target.value)}
            />
            {errors?.power_rpm_ncr && (
              <>
                <span style={{ color: "red" }}>{errors?.power_rpm_ncr}</span>
              </>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-box">
            <label>NCR RPM</label>
            <Input
              value={ncr_rpm}
              placeholder="NCR RPM"
              onChange={(e) => set_ncr_rpm(e.target.value)}
            />
            {errors?.ncr_rpm && (
              <>
                <span style={{ color: "red" }}>{errors?.ncr_rpm}</span>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="row" style={{ marginLeft: "5px", marginBottom: "5px" }}>
        <div style={{ marginRight: "5px" }}>
          <label>EPL Fitted (Yes / No)</label>
        </div>
        <Switch
          value={checked}
          onChange={(checked) => setChecked(checked)}
          checkedChildren="Yes"
          unCheckedChildren="No"
          style={{
            backgroundColor: checked ? "green" : "red",
          }}
        />
      </div>
      {checked && (
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>EPL MCR</label>
              <Input
                value={epl_mcr}
                placeholder="EPL MCR"
                onChange={(e) => set_epl_mcr(e.target.value)}
              />
              {errors?.epl_mcr && (
                <>
                  <span style={{ color: "red" }}>{errors?.epl_mcr}</span>
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>EPL RPM</label>
              <Input
                value={epl_rpm}
                placeholder="EPL RPM"
                onChange={(e) => set_epl_rpm(e.target.value)}
              />
              {errors?.epl_rpm && (
                <>
                  <span style={{ color: "red" }}>{errors?.epl_rpm}</span>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="input-box" style={{ marginTop: "15px" }}>
        <Button type="primary" onClick={ADD_API} loading={loader}>
          save
        </Button>
      </div>
    </>
  );
}

export default ShipMainEngineDetails;
